/**
 * Safely reads browser memory usage
 * Important: reflects memory usage of the entire page (shared JS heap)
 *
 * Note: performance.memory API is only available in Chrome-based browsers
 *
 * @returns Object with used memory in bytes or null if unavailable
 */
export function readMemorySnapshot() {
    try {
        const perf = performance;
        // Check memory API availability
        if (typeof performance === 'undefined' || !perf.memory) {
            return { usedJSHeapSize: null };
        }
        // Read used memory and convert via Number()
        const usedJSHeapSize = perf.memory.usedJSHeapSize !== undefined
            ? Number(perf.memory.usedJSHeapSize)
            : null;
        return { usedJSHeapSize };
    }
    catch {
        return { usedJSHeapSize: null };
    }
}
